export const TURNSTILE_TOKEN_HEADER = "x-turnstile-token";

export type TurnstileAction = "sign-up" | "sign-in" | "inquiry" | "search";
